import React from 'react'

interface Props {
  Items: React.FC
  FiltersBox: React.FC
}
const ListWithStickyFilters: React.FC<Props> = ({ Items, FiltersBox }) => {
  return (
    <div className='flex flex-col-reverse lg:flex-row lg:items-start'>
      <div className='lg:w-3/4'>
        {<Items />}
      </div>
      <div className='lg:w-1/4 inline-block bg-soft-green rounded-lg shadow lg:ml-9 my-3 p-4 sm:p-8 sticky top-0'>
        <FiltersBox />
      </div>
    </div>
  )
}

export default ListWithStickyFilters
